import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { IconPencil } from "@tabler/icons-react";
import { updateDoc } from "firebase/firestore";
import { isEmpty } from "lodash";
import { useState } from "react";
import Functions from "../../../../callable/functions";
import UsuarioDb from "../../../../db/usuarioDb";
import felixAnalytics from "../../../../felixAnalytics";
import { Perfil } from "../../../../models/enum";
import Usuario from "../../../../models/usuario";
import { useSnackBar } from "../../../../stores/snackBarStores";
import FelixAvatar from "../../../util/ui/felixAvatar";

type Props = {
  cliente: Usuario;
  open: boolean;
  onClose: (success: boolean) => void;
};

export default function EditarClienteDialog({ cliente, open, onClose }: Props) {
  const [nome, setNome] = useState<string>(cliente.nome);
  const [email, setEmail] = useState<string>(cliente.email);
  const [editando, setEditando] = useState(false);
  const snackBar = useSnackBar();

  const editarCliente = async () => {
    setEditando(true);
    if (!!!cliente.email && !!email) {
      felixAnalytics.track("enviarConviteCliente");
      await new Functions()
        .enviarConviteCliente({
          id: cliente.id,
          nome: nome,
          email,
        })
        .catch((error) => {
          snackBar({
            type: "ALERT",
            payload: {
              mensagem:
                error.details.code === "auth/email-already-exists"
                  ? `Esse e-mail já está cadastrado na Felix.`
                  : `Houve um erro ao enviar o convite para o cliente. Por favor, tente novamente ou entre em contato com nosso suporte.`,
              severidade: "error",
            },
          });
          console.error(error);
        });
    } else if (!!cliente.email && cliente.email !== email) {
      felixAnalytics.track("editarCliente");
      await new Functions().editarCliente({
        id: cliente.id,
        nome: nome,
        email,
      });
    } else if (cliente.nome !== nome)
      await updateDoc(new UsuarioDb().doc({ usuarioId: cliente.id }), {
        nome: nome,
      }).then(() => {
        snackBar({
          type: "ALERT",
          payload: {
            mensagem: `O cliente ${cliente.nome} foi editado.`,
            severidade: "success",
          },
        });
      });
    setEditando(false);
    onClose(true);
  };

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle color="text.primary">
        <Box display="flex" flexDirection="row" alignItems="center">
          <Box mr={1}>
            <IconPencil size={16} />
          </Box>
          <Typography variant="h4">
            Editar cliente
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center">
          <FelixAvatar
            nome={nome}
            size={64}
            perfil={Perfil.INVESTIDOR}
            fotoDePerfil={cliente.fotoDePerfil}
          />

          <TextField
            sx={{ my: 2 }}
            size="small"
            margin="none"
            fullWidth
            id="nome"
            label="Nome"
            name="nome"
            autoComplete="nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
          />
          <TextField
            sx={{ my: 2 }}
            size="small"
            margin="none"
            fullWidth
            id="email"
            label="Email"
            helperText={
              !!!cliente.email
                ? "Este campo é opcional. Caso preenchido, enviaremos um convite para o cliente acessar a Felix na Bolsa de acordo com as permissões que você definir."
                : undefined
            }
            name="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)} color="inherit">
          Cancelar
        </Button>
        <LoadingButton
          variant="contained"
          size="small"
          color="primary"
          disabled={
            isEmpty(nome) || (cliente.nome === nome && cliente.email === email)
          }
          loading={editando}
          onClick={editarCliente}
        >
          Salvar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
